import axios from "axios";

// For common config
axios.defaults.headers.post["Content-Type"] = "application/json";

const wpBase = axios.create({
  baseURL: "https://www.finditz.com",
});

const realtyBase = axios.create({
  baseURL: "https://api.realestateapi.com",
  headers: {
    accept: "application/json",
    "x-user-id": "UniqueUserIdentifier",
    "content-type": "application/json",
    "x-api-key": `${process.env.REACT_APP_REALTY_API_KEY}`,
  },
});

export { wpBase, realtyBase };
